import Vuex from 'vuex'
import { Message } from 'element-ui';

const Home = resolve => require(['../views/Home/Home'], resolve)
const hotLineCall = resolve => require(['../views/hotLineCall/hotLineCall'], resolve)
const onLineDom = resolve => require(['../views/onLineDom/onLineDom'], resolve)

const state = {
	menu: {
		visible: false,
		top: 0,
		left: 0,
		data: null,
		url: ''
	},
	activeTabName: "999",//当前选中的tab
	iframeUrl: '',//外链的iframe
	msgTabNum: '1',//区别顶部消息打开方式和左侧菜单消息打开方式，1的话就是左侧菜单打开的消息页面,否则就是从顶部消息列表打开的消息页面，并且会传入当前点击的消息对象
	msgNumTotal: '0',
	publicKey: '',//登录后取得的密匙
	openNum: null,
	tabList: [
		{
			label: '工单工作台',
			name: '999',
			disabled: false,
			isLoad: true,//刷新当前组件
			closable: false,//是否允许关闭
			component: Home
		},
		{
			label: '电话热线',
			name: '888',
			disabled: true,
			isLoad: true,//刷新当前组件
			closable: false,//是否允许关闭
			component: hotLineCall
		},
		{
			label: '线上客服',
			name: '777',
			disabled: true,
			isLoad: true,//刷新当前组件
			closable: false,//是否允许关闭
			component: onLineDom
		}
	],
	//热线顶部栏图标操作
	hotLineNum: 0, //热线数量
	onLineNum: 0, //在线数量
	linkBookShow: false,
	openAgentType: 0, //工具栏使用的坐席弹窗类型
	openIVR: 0, //工具栏使用的ivr弹窗
	openSkill: 0, //工具栏使用的技能弹窗
	openHoldCall: 0, //工具栏使用的保持通话弹窗
	smsPhoneNum: 0, //打开短信弹窗传进去的号码
	emailAddress: 0, //打开邮件发送页面传进去的邮箱地址
	callPopData: null, //来电弹屏 - 电话热线标签
	callPopDataDialog: null, //来电弹屏 - 弹窗方式
	comePhoneTip: null, //来电弹屏通知
	cusOrderData: null, //与业务工单交互保存关联数据集
	clearCall: null, //清空来电弹屏的通话状态
	picPath: '', //头像
	agentStatus: [], //坐席状态列表
	menuList: [], //菜单
	workorderclose: null, //关闭工单的开关
	hlSet: 0,
	otherParams: null, //弹屏时使用的额外序列化参数
	unresolvedNum: 0, //我的未解决工单数量
	groupUnResolvedNum: 0, //组内未解决工单数量
	isChangeNum: 0,
	unresolvedObj: {
		orderId: '', //工单Id
		editType: '', //工单编辑类型
	},
	groupUnresolvedObj: {
		orderId: '', //工单Id
		editType: '', //工单编辑类型
	},
	openTipObj: null, //需要打开的消息对象
	openNoticObj: null, //需要打开的公告对象
}

const mutations = {
	setLinkBookShow(state, name){
		state.linkBookShow = name;
	},
	setActiveHomeopenNum(state, name) {
		state.openNum = name;
	},
	setActiveHomeAid(state, name) {
		state.homeAid = name;
	},
	setActivePublicKey(state, name) {
		state.publicKey = name;
	},
	setActiveTabName(state, name) {
		state.activeTabName = name;
	},
	setmsgTabNum(state, name) {
		state.msgTabNum = name;
	},
	setmsgNumTotal(state, name) {
		state.msgNumTotal = name;
	},
	setiframeUrl(state, url) {
		state.iframeUrl = url;
	},
	isopenMenu(state, type) {
		state.menu.visible = type
	},
	openMenu(state, even) {
		// console.log(state);
		// console.log(even);
		//class有notRight的tabs不使用右键菜单
		let show = true
		//因为谷歌浏览器新版本删除了path属性，只能通过parentNode一层层往上找
		let evenPath = even.path?even.path:mutations.composedPath(even)
		// console.log(evenPath)
		evenPath.map((o) => {
			if (o.className && o.className.indexOf('notRight') > -1) {
				show = false
			}
		})
		try {
			if (even.target._prevClass.indexOf('el-tabs__item') != -1 && show) {
				state.menu.visible = true;
				state.menu.top = even.clientY;
				state.menu.left = even.clientX;
				state.menu.data = state;
				state.menu.url = state.iframeUrl;
			}
		} catch (err) { }
	},
	composedPath(even, arr){
		// 不存在则遍历target节点
		if(!arr){
			arr = []
		}
		let target = even.target
		while (target.parentNode !== null) {
			arr.push(target)
			target = target.parentNode
		}
		if(target.parentNode){
			mutations.composedPath(even, arr)
		}else{
			return arr
		}
	},
	//打开页面tab，外链传参例子：this.addTab({webUrl:'https://www.focustar.net', menuId:'聚星源', menuName:'聚星源'})
	//内部组件传参例子：this.addTab({webUrl:'QuickLink/QuickLink', menuId:'快速入口配置', menuName:'快速入口配置'})
	//或使用this.getMenuItem(JSON.parse(this.$store.state.navTabs.menuList), 'QuickLink/QuickLink')获取到对应的菜单obj对象后，使用this.addTab(obj)打开
	//或：this.addTab({webUrl:'QuickLink', menuGroupFileName:'QuickLink', menuId:'快速入口配置', menuName:'快速入口配置'})
	addTab(state, menuItem) {
		console.log(menuItem);
		var menu = menuItem;
		var menuUrl = menu.webUrl;
		var menuId = menu.menuId;
		var menuName = menu.menuName;
		if (state.tabList.filter(f => f.name == menuName) == 0) { //使用菜单名称来区分tab
			let components = '';
			//"@"相当于".."
			if (menuUrl.startsWith("http://") || menuUrl.startsWith("https://")) {
				//打开外链页面
				if (menuUrl.indexOf("?") == -1) {
					menuUrl = menuUrl + "?";
				}
				var params = menu.menuParamList
				if (params != null && params != "") {
					var obj = JSON.parse(LocalStorage.getItem("obj"))
					for (var i = 0; i < params.length; i++) {
						var para = params[i]
						//1.坐席工号 2.坐席名称 3.分机号 4.VDNID 5.token
						var dynamicValue = para.dynamicValue
						if (dynamicValue === 1) {
							dynamicValue = obj.workNo
						} else if (dynamicValue === 2) {
							dynamicValue = obj.userName
						} else if (dynamicValue === 3) {
							dynamicValue = obj.extNum
						} else if (dynamicValue === 4) {
							dynamicValue = obj.vdnId
						} else if (dynamicValue === 5) {
							dynamicValue = obj.authToken.replace('Bearer ', '')
						}
						if(menuUrl.substr(menuUrl.length - 1, 1) == '?'){
							menuUrl = menuUrl + para.paramCode + "=" + dynamicValue
						}else if(menuUrl.substr(menuUrl.length - 1, 1) == '&'){
							menuUrl = menuUrl + para.paramCode + "=" + dynamicValue
						}else{
							menuUrl = menuUrl + "&" + para.paramCode + "=" + dynamicValue
						}
					}
				}

				//微服务框架携带参数
				if(window._CONFIG.isMicroservice){
					menuUrl = menuUrl + '&isMs=' + window.APIURL.projectName;
				}

				//检查外链页面打开方式
				if(menuItem.target == 2){
					//打开浏览器新标签页
					window.open(menuUrl)
					return false
				}
				let urlObj = menuUrl.split('?')[0].split('/')
				let urlObj2 = urlObj[urlObj.length-1]
				let viewName = urlObj2
				if (urlObj2.indexOf('.')>-1) viewName = urlObj2.split('.')[0]
				let component = resolve => require([`../views/User/User.vue`], resolve);
				let json = {
					label: menuName,
					not_menu: true,
					name: menuName, //此name需要对应state.activeTabName的值
					disabled: false,
					isLoad: true,
					closable: true,
					iframeUrl: menuUrl,
					viewName: viewName,
					component: component
				}
				state.tabList.push(json)

				//延时往子系统页面发送权限信息
				let tNum = 0
				let myInt= setInterval(()=>{
					tNum++
					let len = window.frames.length
					let powerList = SessionStorage.getItem('powerList')
					for(var i = 0; i < len; i++){
						window.frames[i].postMessage({message: 'powerList', powerList: powerList}, '*')
					}
					if(tNum >= 5){
						//推送5次确保能正常送达
						clearInterval(myInt)
						myInt = null
					}
				}, 2000)
				
			} else {
				if (menu.menuGroupFileName) {
					components = resolve => require([`../views/${menu.menuGroupFileName}/${menuUrl}.vue`], resolve);
				} else {
					components = resolve => require([`../views/${menuUrl}.vue`], resolve);
				}
				state.tabList.push({
					label: menuName,
					name: menuName, //此name需要对应state.activeTabName的值
					disabled: false,
					isLoad: true,
					closable: true,
					component: components
				})
			}

		}
		state.activeTabName = menuName;
	},
	//关闭tab，传入菜单名称
	closeTab(state, name) {
		const self = this
		// console.log('-----')
		// console.log(state);
		// console.log(name);//当前选择的tab名字
		let viewObj = state.tabList.filter(item => {
			return name == item.name
		})
		let viewName = viewObj[0].viewName
		if (viewName == 'Assistant') {
			let obj = $("#pane-"+viewObj[0].name+" iframe")[0]
			obj.contentWindow.postMessage({message: 'closeZS'}, '*')
			setTimeout(function() {
				mutations.closeFn(state, name)
			}, 500)
		} else if (viewName == 'Monitor') {
			let obj = $("#pane-"+viewObj[0].name+" iframe")[0]
			obj.contentWindow.postMessage({message: 'closeJK'}, '*')
			setTimeout(function() {
				mutations.closeFn(state, name)
			}, 500)
		} else {
			mutations.closeFn(state, name)
		}

	},
	closeFn(state, name) {
		state.homeAid = ''
		let tab = state.tabList.filter(f => f.name == name)[0];
		let index = state.tabList.indexOf(tab);
		if (name == state.activeTabName) {//关闭的tab是当前选中的tab 才调整选中位置
			if (index != state.tabList.length - 1) {
				state.activeTabName = state.tabList[index + 1].name;
			} else {
				if(state.tabList[index - 1].disabled){
					//前一个tab是隐藏的，这里特指来电弹屏和线上客服，切回工单工作台
					state.activeTabName = state.tabList[0].name;
				}else{
					state.activeTabName = state.tabList[index - 1].name;
				}
			}
		}
		state.tabList = state.tabList.filter(f => f.name != name);
	},
	closeOthers(state, name) {
		let ishaszs = state.tabList.filter((f) => { return f.viewName == 'Assistant' })
		let ishasjk = state.tabList.filter((f) => { return f.viewName == 'Monitor' })
		if (ishaszs.length||ishasjk.length) {
			if (ishaszs.length&&state.activeTabName!=ishaszs[0].name) {
				let objZS = $("#pane-"+ishaszs[0].name+" iframe")[0]
				if (objZS) objZS.contentWindow.postMessage({message: 'closeZS'}, '*')
			}
			if (ishasjk.length&&state.activeTabName!=ishasjk[0].name) {
				let objJK = $("#pane-"+ishasjk[0].name+" iframe")[0]
				if (objJK) objJK.contentWindow.postMessage({message: 'closeJK'}, '*')
			}
			setTimeout(function() {
				let tab = state.tabList.filter((f) => {
					return f.name == state.activeTabName | f.closable == false
				})
				state.tabList = tab
			}, 500)
		} else {
			let tab = state.tabList.filter((f) => {
				return f.name == state.activeTabName | f.closable == false
			})
			state.tabList = tab
		}
	},
	closeAll(state, name) {
		let ishaszs = state.tabList.filter((f) => { return f.viewName == 'Assistant' })
		let ishasjk = state.tabList.filter((f) => { return f.viewName == 'Monitor' })
		if (ishaszs.length||ishasjk.length) {
			if (ishaszs.length) {
				let objZS = $("#pane-"+ishaszs[0].name+" iframe")[0]
				if (objZS) objZS.contentWindow.postMessage({message: 'closeZS'}, '*')
			}
			if (ishasjk.length) {
				let objJK = $("#pane-"+ishasjk[0].name+" iframe")[0]
				if (objJK) objJK.contentWindow.postMessage({message: 'closeJK'}, '*')
			}
			setTimeout(function() {
				let tab = state.tabList.filter((f) => { return f.closable == false })
				state.activeTabName = '999'
				state.tabList = tab
			}, 500)
		} else {
			let tab = state.tabList.filter((f) => { return f.closable == false })
			state.activeTabName = '999'
			state.tabList = tab
		}
 	},
	LOGOUT(state) {//退出之后需要默认设置工单工作台为tabs
		state.activeTabName = '999';
		state.tabList = [
			{
				label: '工单工作台',
				name: '999',
				disabled: false,
				isLoad: true,
				closable: false,
				component: Home
			},
			{
				label: '电话热线',
				name: '888',
				disabled: true,
				isLoad: true,
				closable: false,
				component: hotLineCall
			},
			{
				label: '线上客服',
				name: '777',
				disabled: true,
				isLoad: true,
				closable: false,
				component: onLineDom
			}
		];
	}
}

export default {
	namespaced: true,
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/navTabs.js